import { render, staticRenderFns } from "./Ratio.vue?vue&type=template&id=57c86ace&scoped=true&"
import script from "./Ratio.vue?vue&type=script&lang=js&"
export * from "./Ratio.vue?vue&type=script&lang=js&"
import style0 from "./Ratio.vue?vue&type=style&index=0&id=57c86ace&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57c86ace",
  null
  
)

export default component.exports